import { lazy } from "react";
import { RouteSuspense } from "@/shared/routing/RouteSuspense";
import type { RouteObject } from "react-router-dom";
import { Navigate, useParams } from "react-router-dom";

import { useLocale } from "@seller/app/locale";

const DashboardPage = lazy(() => import("@/modules/dashboard/pages/DashboardPage").then(module => ({ default: module.DashboardPage })));

function SellerDashboardRoute() {
  const locale = useLocale();
  const { storeSlug = "" } = useParams();

  return <DashboardPage locale={locale} storeSlug={storeSlug} />;
}

export const dashboardRoutes: RouteObject[] = [
  {
    index: true,
    element: <Navigate to="dashboard" replace />,
  },
  {
    path: "dashboard",
    element: <RouteSuspense><SellerDashboardRoute /></RouteSuspense>,
  },
];
